export function capitalize(name) {
  var stripped = name.replace(/\s/gi, '').replace(/\.svg$/, '').split('-').map(function (s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
  });
  return stripped.join('');
}